<script setup lang="ts">
import { HomeButton } from '@/components/home'
import { computed } from 'vue'
import type { PathwayEvent } from '@/types/shared/pathway-event'
import { usePathwayEvent } from '@/composables/game/pathway-events'

const props = defineProps<{
  pathwayEvent: PathwayEvent
}>()

const { countdownForEventEnd } = usePathwayEvent(props.pathwayEvent)

const containerStyle = computed(() => {
  return { background: `linear-gradient(90deg, ${props.pathwayEvent.mainColor} 0%, #1C1C1E 100%)` }
})
</script>

<template>
  <HomeButton
    variant="bottom"
    v-if="pathwayEvent"
    no-border
    :label="pathwayEvent.eventName"
    :countdown="{ value: countdownForEventEnd, dangerThreshold: 3600 * 12 }"
  >
    <img
      class="size-[27px] object-cover"
      :src="pathwayEvent.mainIcon"
    >
  </HomeButton>
</template>
